<template>
	<aside class="aside" v-if="activeRouteName !== 'AutoLogin' && !smallScreen">
		<router-link to="/rundowns">{{ $t('Rundown') }}</router-link>
		<router-link to="/compositions">{{ $t('Composition') }}</router-link>
		<router-link v-if="isSuperAdmin || isClient" to="/collaborators">{{ $t('Collaborator') }}</router-link>
		<router-link to="/displays" v-if="!isCollaborator">{{ $t('View Output') }}</router-link>
		<router-link to="/settings">{{ $t('Account & Settings') }}</router-link>
		<router-link to="/billings" v-if="(!isCollaborator && isHaveTransactions) || isSuperAdmin">{{ $t('Billing') }}</router-link>
		<router-link to="/display-sizes" v-if="isSuperAdmin">{{ $t('Display Sizes') }}</router-link>
		<div @click="openTemplate" v-if="isSuperAdmin" class="pointer mb-3 pb-2">{{ $t('Manage Templates') }}</div>
		<router-link to="/categories" v-if="isSuperAdmin">{{ $t('Manage Categories') }}</router-link>
		<div @click="openGallery" v-if="isSuperAdmin" class="pointer mb-3 pb-2">{{ $t('Manage Galleries') }}</div>
		<router-link to="/packages" v-if="isSuperAdmin">{{ $t('Manage Packages') }}</router-link>
		<router-link to="/promos" v-if="isSuperAdmin">{{ $t('Manage Promos') }}</router-link>
		<!-- <router-link to="https://feedback.grafi.as/" v-if="isSuperAdmin">{{ $t('Manage Feedbacks') }}</router-link> -->
		<router-link to="/statistics" v-if="isSuperAdmin">{{ $t('Statistics') }}</router-link>
		<router-link to="/my-statistics" v-if="!isSuperAdmin">{{ $t('My Statistics') }}</router-link>
		<router-link to="/users" v-if="isSuperAdmin">{{ $t('Users') }}</router-link>
		<router-link to="/users-log" v-if="isSuperAdmin">{{ $t('User Logs') }}</router-link>
		<router-link to="/announcements" v-if="isSuperAdmin">{{ $t('Announcements') }}</router-link>
		<template-popup
			@close="isTemplate = false"
			v-if="isTemplate"
		/>
		<gallery-popup
			@close="isGallery = false"
			v-if="isGallery"
		/>
	</aside>
</template>

<script>

import { mapGetters } from 'vuex';

import TemplatePopup from '@/components/TemplatePopup.vue';
import GalleryPopup from '@/components/GalleryPopup.vue';

export default {
	name: 'SideNav',
	props: {
		user: {
			type: Object,
		},
	},
	data() {
		return {
			isTemplate: false,
			isGallery: false,
			smallScreen: false,
		};
	},
	components: {
		TemplatePopup,
		GalleryPopup,
	},
	methods: {
		openTemplate() {
			this.isTemplate = true;
		},
		openGallery() {
			this.isGallery = true;
		},
		onResizeWidth() {
			if (window.innerWidth <= 1024) {
				this.smallScreen = true;
			} else {
				this.smallScreen = false;
			}
		},
	},
	computed: {
		...mapGetters({
			role: 'role',
			isMenuActive: 'isMenuActive',
			isSuperAdmin: 'isSuperAdmin',
			isClient: 'isClient',
			isCollaborator: 'isCollaborator',
		}),
		activeRouteName() {
			return this.$route.name;
		},
		isSuperAdminIncluded() {
			return this.user && this.user.roles.includes('super_admin');
		},
		isHaveTransactions() {
			return this.user && this.user.transactions && this.user.transactions.length > 0;
		},
	},
	mounted() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
	},
	created() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
	},
};
</script>
